import { useSettings } from '../hooks/useSettings';
import { useAuth } from '../contexts/AuthContext';
import { TenantSelector } from './TenantSelector';

interface HeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function Header({ title, subtitle, actions }: HeaderProps) {
  const { settings } = useSettings();
  const { user } = useAuth();

  const getUserRoleText = (role: string) => {
    switch (role) {
      case 'ADMIN':
        return 'Administrador';
      case 'SUPERADMIN':
        return 'Super Administrador';
      case 'USER':
        return 'Usuário';
      default:
        return 'Usuário';
    }
  };

  return (
    <header className="sticky top-0 z-10 border-b border-slate-200/80 bg-white/90 px-4 py-4 backdrop-blur-xl sm:px-6">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex min-w-0 items-center gap-4">
          <div className="hidden h-12 w-12 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 shadow-sm sm:flex">
            <img
              src={settings?.logoUrl || '/assets/default-logo.png'}
              alt={settings?.companyName || 'LeadNexia'}
              className="h-7 w-auto object-contain"
            />
          </div>

          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="truncate text-2xl font-semibold tracking-tight text-slate-950">{title}</h1>
              <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-500">
                {settings?.companyName || 'LeadNexia'}
              </span>
            </div>
            {subtitle && (
              <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
          <div className="flex flex-wrap items-center gap-3">
            <div className="min-w-[180px]">
              <TenantSelector />
            </div>

            <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-3 py-2.5 shadow-sm">
              <div
                className="flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-900 text-sm font-semibold text-white"
                aria-hidden="true"
              >
                {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-semibold text-slate-900">{user?.nome || 'Usuário'}</p>
                <p className="truncate text-xs text-slate-500">{getUserRoleText(user?.role || 'USER')}</p>
              </div>
            </div>
          </div>

          {actions && (
            <div className="flex items-center justify-end lg:border-l lg:border-slate-200 lg:pl-4">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
